// src/layouts/MainLayout.jsx
import React from "react";
import SideNavbar from "../components/SideNavbar";
import Topbar from "../components/Topbar"; // we’ll create this next
import "./MainLayout.css";

const MainLayout = ({ children, isLoggedIn, setIsLoggedIn }) => {
  return (
    <div className="main-layout">
      <Topbar />

      <div className="content-area">
        {isLoggedIn && (
          <SideNavbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
        )}
        <main className="main-section">{children}</main>
      </div>
    </div>
  );
};

export default MainLayout;
